(() => {
  const root = document.querySelector('stg-size-comparison');
  if (!root || root.dataset.ready || typeof HTMLDialogElement === 'undefined') return;
  const data = JSON.parse(root.querySelector('.stg-sc-data').textContent);
  const normalize = value => String(value).toLowerCase().replace(/[\s"″]/g, '').replace('×', 'x');
  const custom = root.dataset.custom === 'true';
  const dimensions = value => {
    const normalized = normalize(value);
    if (!custom && !/^(12x18|16x24|24x36|18x12|24x16|36x24)$/.test(normalized)) return null;
    if (!/^\d+(?:\.\d+)?x\d+(?:\.\d+)?$/.test(normalized)) return null;
    const dims = normalized.split('x').map(Number);
    return dims.every(n => Number.isFinite(n) && n > 0 && n <= 120) ? dims : null;
  };
  const sizeIndex = data.options.findIndex((name, i) => /size/i.test(name) && data.variants.every(v => dimensions(v.options[i])));
  if (sizeIndex < 0) return;
  const rawSizes = [...new Set(data.variants.map(v => v.options[sizeIndex]))];
  if (!rawSizes.length || rawSizes.some(s => !dimensions(s))) return;
  const sizes = rawSizes.map(value => ({value, dims: dimensions(value)})).sort((a,b) => a.dims[0]*a.dims[1]-b.dims[0]*b.dims[1]);
  if (!custom && new Set(sizes.map(s => Math.min(...s.dims))).size !== sizes.length) return;
  const dialog = root.querySelector('dialog');
  const trigger = root.querySelector('.stg-sc-trigger');
  const canvas = root.querySelector('.stg-sc-canvas');
  const legend = root.querySelector('.stg-sc-legend');
  const formId = 'main-product-form-' + data.productId;
  let horizontal = data.tags.some(t => /^landscape$/i.test(t)) || sizes.every(s => s.dims[0] > s.dims[1]);
  let frame = 0;
  let previousOverflow = '';
  let busy = false;
  let failed = false;
  const statusMessage = root.querySelector('.stg-sc-status');
  const matching = (size, selected) => data.variants.filter(v => v.options.every((value,i) => i === sizeIndex ? normalize(value) === normalize(size) : selected[i] === value));
  const formSection = () => document.getElementById(formId)?.closest('.m6pr, .m6pr-compact');
  const selections = () => {
    const values = data.options.map(name => {
      const controls = [...document.querySelectorAll('[data-standard-option-name]')].filter(el => el.getAttribute('form') === formId && el.dataset.standardOptionName === name);
      const field = controls.find(el => el.tagName === 'SELECT' || el.checked);
      return field ? field.value : null;
    });
    if (values.every(v => v !== null)) return values;
    const variantControl = [...document.querySelectorAll('[name="variant-id"]')].find(el => el.getAttribute('form') === formId && (el.checked || el.tagName === 'SELECT'));
    const id = variantControl?.value || document.querySelector('#' + formId + ' [name="id"]')?.value;
    const variant = data.variants.find(v => String(v.id) === String(id || data.selectedId));
    return variant ? variant.options : values;
  };
  const render = () => {
    const focusKey = dialog.contains(document.activeElement) ? document.activeElement.dataset.focusKey : null;
    const confirmedId=formSection()?.querySelector('[data-current-variant]')?.dataset.currentVariant;
    const selected = failed ? (data.variants.find(v=>String(v.id)===String(confirmedId))?.options || []) : selections();
    const maxLong = Math.max(...sizes.map(s => Math.max(...s.dims)));
    const maxShort = Math.max(...sizes.map(s => Math.min(...s.dims)));
    const availableW = canvas.clientWidth - 36;
    const availableH = canvas.clientHeight - 36;
    const scale = Math.min(availableW / (horizontal ? maxLong : maxShort), availableH / (horizontal ? maxShort : maxLong));
    canvas.replaceChildren(); legend.replaceChildren();
    if (!custom) [...sizes].reverse().forEach(s => {
      const chosen = normalize(selected[sizeIndex]) === normalize(s.value);
      const outline = document.createElement('button'); outline.type='button'; outline.className = 'stg-sc-outline'; outline.dataset.selected = String(chosen);
      configureButton(outline,s,selected,'outline');
      const short = Math.min(...s.dims), long = Math.max(...s.dims);
      outline.style.width = (horizontal ? long : short) * scale + 'px';
      outline.style.height = (horizontal ? short : long) * scale + 'px';
      const label = document.createElement('span');label.textContent = s.dims.join(' × ') + ' in';outline.append(label);canvas.append(outline);
    });
    sizes.forEach(s => {
      const matches = matching(s.value,selected);
      const chosen = normalize(selected[sizeIndex]) === normalize(s.value);
      const row = document.createElement('li');row.dataset.selected = String(chosen);row.dataset.offered = String(matches.length > 0);
      const label = document.createElement('span');label.textContent = s.dims.join(' × ') + ' in';
      const status = document.createElement('span');status.textContent = [chosen ? data.labels.selected : '', !matches.length ? data.labels.unavailable : matches.some(v => v.available) ? (chosen ? '' : data.labels.offered) : data.labels.soldOut].filter(Boolean).join(' · ');
      const button = document.createElement('button'); button.type='button'; button.className='stg-sc-size-button'; configureButton(button,s,selected,'card');
      if (custom) {
        const visual = document.createElement('div'); visual.className = 'stg-sc-card-visual'; visual.setAttribute('aria-hidden','true');
        const outline = document.createElement('div'); outline.className = 'stg-sc-card-outline';
        const maxSide = Math.max(...sizes.flatMap(item => item.dims));
        const short = Math.min(...s.dims), long = Math.max(...s.dims);
        outline.style.width = ((horizontal ? long : short) / maxSide * 100) + '%';
        outline.style.height = ((horizontal ? short : long) / maxSide * 100) + '%';
        visual.append(outline); button.append(visual);
      }
      button.append(label,status);row.append(button);legend.append(row);
    });
    root.querySelector('.stg-sc-rotate').disabled = busy;
    if (focusKey) {const focused=[...root.querySelectorAll('[data-focus-key]')].find(el=>el.dataset.focusKey===focusKey); if(focused && !focused.disabled)focused.focus({preventScroll:true});}
    root.querySelector('.stg-sc-rotate').setAttribute('aria-label', (horizontal ? data.labels.horizontal : data.labels.vertical) + '. ' + root.querySelector('.stg-sc-rotate').textContent);
  };
  const configureButton = (button, size, selected, kind) => {
    const chosen = normalize(selected[sizeIndex]) === normalize(size.value);
    button.dataset.size=size.value; button.dataset.focusKey=kind+':'+size.value;
    button.setAttribute('aria-pressed', String(chosen));
    const matches=matching(size.value,selected);
    const availability=!matches.length?data.labels.unavailable:matches.some(v=>v.available)?'':data.labels.soldOut;
    button.setAttribute('aria-label', data.labels.select+' '+size.dims.join(' × ')+' in'+(kind==='outline'?' '+data.labels.outline:'')+(availability?'. '+availability:''));
    button.disabled=busy || failed || !matches.some(v=>v.available);
    button.addEventListener('click',()=>selectSize(size.value));
  };
  const selectSize = async value => {
    if (busy || failed) return;
    const selected=selections();
    const variant=matching(value,selected).find(v=>v.available);
    if(!variant || normalize(selected[sizeIndex])===normalize(value))return;
    const section=formSection();
    const controls=[...document.querySelectorAll('[data-standard-option-name]')].filter(el=>el.getAttribute('form')===formId && el.dataset.standardOptionName===data.options[sizeIndex]);
    let control=controls.find(el=>el.tagName==='SELECT' || normalize(el.value)===normalize(value));
    let nextValue=value;
    if(!control){control=[...document.querySelectorAll('[name="variant-id"]')].find(el=>el.getAttribute('form')===formId && (el.tagName==='SELECT'||String(el.value)===String(variant.id)));nextValue=String(variant.id);}
    const option=control?.tagName==='SELECT' ? [...control.options].find(o=>normalize(o.value)===normalize(nextValue)) : control;
    const targetUrl=option?.dataset.productUrl;
    const currentUrl=section?.dataset.productUrl;
    if(!section || !control?.isConnected || control.disabled || !control.classList.contains('listening') || !option || (targetUrl && new URL(targetUrl,location.href).pathname!==new URL(currentUrl || location.href,location.href).pathname)){
      failed=true;statusMessage.textContent=data.labels.failed;render();return;
    }
    if(section.querySelector('form.processing'))return;
    const uploads=[...document.querySelectorAll('input[type="file"]')].filter(el=>el.files?.length).map(el=>({el,files:[...el.files]}));
    busy=true; statusMessage.textContent=data.labels.updating; root.setAttribute('aria-busy','true');render();
    root.querySelector('.stg-sc-close').focus({preventScroll:true});
    try {
      if(control.tagName==='SELECT')control.value=nextValue;else control.checked=true;
      const event=new Event('change',{bubbles:true});event.xtraStandardProductSelectSource=control;control.dispatchEvent(event);
      await new Promise((resolve,reject)=>{
        const started=Date.now();
        const check=()=>{
          const current=formSection();
          const confirmed=current?.querySelector('[data-current-variant]')?.dataset.currentVariant;
          if(Date.now()-started>150 && String(confirmed)===String(variant.id) && !current.querySelector('form.processing'))return resolve();
          if(!root.isConnected || !current || Date.now()-started>20000)return reject(new Error('Size update not confirmed'));
          setTimeout(check,100);
        };setTimeout(check,100);
      });
      const intact=uploads.every(({el,files})=>el.isConnected && el.files?.length===files.length && files.every((f,i)=>el.files[i]===f));
      statusMessage.textContent=intact?data.labels.updated:data.labels.uploadWarning;
      if(!intact)failed=true;
    } catch(error) {failed=true;statusMessage.textContent=data.labels.failed;}
    finally {busy=false;root.removeAttribute('aria-busy');render();if(dialog.open)root.querySelector('.stg-sc-close').focus({preventScroll:true});}
  };
  const place = () => {
    frame = 0;
    let bottom = 84;
    const sticky = document.getElementById('sticky-add-to-cart');
    if (sticky && sticky.getAttribute('aria-hidden') !== 'true') {
      const rect = sticky.getBoundingClientRect();
      if (rect.top < innerHeight && rect.bottom > innerHeight - 150 && getComputedStyle(sticky).visibility !== 'hidden') bottom = Math.max(bottom, innerHeight - rect.top + 12);
    }
    const preview = document.getElementById('PBarNextFrame');
    if (preview) bottom = Math.max(bottom, 84);
    root.style.setProperty('--stg-sc-bottom', bottom + 'px');
    const blocked = ['m6pn-open','m6cp-open','f8fl-open','m2a','m2a-delay','search-full','search-full-mode','search-compact-active','menu-open'].some(c => document.documentElement.classList.contains(c)) || document.documentElement.classList.contains('search-open') || document.documentElement.classList.contains('cart-open') || document.body.classList.contains('cart-open');
    trigger.style.visibility = blocked ? 'hidden' : '';
  };
  const schedule = () => {if (!frame) frame = requestAnimationFrame(place);};
  trigger.addEventListener('click', () => {previousOverflow = document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow = 'hidden';render();root.querySelector('.stg-sc-close').focus();});
  root.querySelector('.stg-sc-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', e => {if(e.target === dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('keydown', e => {if(e.key !== 'Tab') return; const enabled=[...dialog.querySelectorAll('button:not([disabled])')].filter(el=>el.getClientRects().length); const first=enabled[0],last=enabled[enabled.length-1];if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}});
  dialog.addEventListener('close', () => {document.documentElement.style.overflow=previousOverflow;trigger.focus({preventScroll:true});});
  root.querySelector('.stg-sc-rotate').addEventListener('click', () => {horizontal=!horizontal;render();});
  document.addEventListener('change', () => {if(dialog.open)render();schedule();});
  window.addEventListener('resize', () => {if(dialog.open)render();schedule();},{passive:true});
  window.addEventListener('scroll', schedule,{passive:true});
  new MutationObserver(schedule).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  const sticky = document.getElementById('sticky-add-to-cart');if(sticky)new MutationObserver(schedule).observe(sticky,{attributes:true,attributeFilter:['class','aria-hidden','style']});
  root.dataset.ready='true';root.hidden=false;place();
})();
